import {
	Laboratory,
	ExtractBrand,
	ExtractCategory,
	ExtractSupplier,
	ExtractUser,
	ExtractProduct,
	ExtractScheduleType,
	DictionaryUser,
	DictionaryBrand,
	DictionaryCategory,
	DictionarySupplier,
	DictionaryProduct,
	DictionaryScheduleType,
	LoadingStatusEnum,
	BaseEtlImport,
	ExtractLaboratory,
	DictionaryLaboratory,
} from "etl/types";

export type ItemMapping = {
	extractId: number;
	dicoId: number;
};

export interface EtlDataState {
	// app
	appIsInitialized: boolean;
	// imports
	isLoadingImports: boolean;
	etlImports: BaseEtlImport[];
	selectedEtlImportUuid: string | null;
	// laboratories
	isLoadingLaboratories: boolean;
	laboratories: Laboratory[];
	// users
	usersLoadingStatus: LoadingStatusEnum;
	extractUsers: ExtractUser[];
	dictionaryUsers: DictionaryUser[];
	// brands
	brandsLoadingStatus: LoadingStatusEnum;
	extractBrands: ExtractBrand[];
	dictionaryBrands: DictionaryBrand[];
	// suppliers
	suppliersLoadingStatus: LoadingStatusEnum;
	extractSuppliers: ExtractSupplier[];
	dictionarySuppliers: DictionarySupplier[];
	// categories
	categoriesLoadingStatus: LoadingStatusEnum;
	extractCategories: ExtractCategory[];
	dictionaryCategories: DictionaryCategory[];
	// products
	productsLoadingStatus: LoadingStatusEnum;
	extractProducts: ExtractProduct[];
	dictionaryProducts: DictionaryProduct[];
	// schedule types
	scheduleTypesLoadingStatus: LoadingStatusEnum;
	extractScheduleTypes: ExtractScheduleType[];
	dictionaryScheduleTypes: DictionaryScheduleType[];
	// laboratories
	laboratoriesLoadingStatus: LoadingStatusEnum;
	extractLaboratories: ExtractLaboratory[];
	dictionaryLaboratories: DictionaryLaboratory[];
};

export const etlDataReducerInit = (): EtlDataState => {
	return {
		// app
		appIsInitialized: false,
		// imports
		isLoadingImports: false,
		etlImports: [],
		selectedEtlImportUuid: null,
		// laboratories
		isLoadingLaboratories: false,
		laboratories: [],
		// users
		usersLoadingStatus: LoadingStatusEnum.NotLoaded,
		extractUsers: [],
		dictionaryUsers: [],
		// brands
		brandsLoadingStatus: LoadingStatusEnum.NotLoaded,
		extractBrands: [],
		dictionaryBrands: [],
		// suppliers
		suppliersLoadingStatus: LoadingStatusEnum.NotLoaded,
		extractSuppliers: [],
		dictionarySuppliers: [],
		// categories
		categoriesLoadingStatus: LoadingStatusEnum.NotLoaded,
		extractCategories: [],
		dictionaryCategories: [],
		// products
		productsLoadingStatus: LoadingStatusEnum.NotLoaded,
		extractProducts: [],
		dictionaryProducts: [],
		// schedule types
		scheduleTypesLoadingStatus: LoadingStatusEnum.NotLoaded,
		extractScheduleTypes: [],
		dictionaryScheduleTypes: [],
		// laboratories
		laboratoriesLoadingStatus: LoadingStatusEnum.NotLoaded,
		extractLaboratories: [],
		dictionaryLaboratories: [],
	}
};
